import { Address } from 'viem';

import { getPublicClient } from 'modules/api/getPublicClient';
import { memoizePromise } from 'modules/api/methods/memoizePromise';

const safeAbi = [
  {
    type: 'function',
    name: 'VERSION',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'string' }],
  },
] as const;

export async function _isSafeAccount(address: Address): Promise<boolean> {
  try {
    const client = getPublicClient();
    const code = await client.getCode({ address });
    if (!code || code === '0x') {
      return false;
    }

    const version = await client.readContract({
      address,
      abi: safeAbi,
      functionName: 'VERSION',
    });

    return typeof version === 'string';
  } catch {
    return false;
  }
}

export const isSafeAccount = memoizePromise(_isSafeAccount, address => address);
